export default __webpack_public_path__ + "static/media/EtheriumLogoImg.e867c9a9.png";